import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=8e0cc0f8&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=8e0cc0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0cc0f8",
  null
  
)

export default component.exports